import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { PagedResponse } from "../types/Common";
import { BillingInfo } from "../types/billingInfo";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string) => () =>
  axios.get<PagedResponse<BillingInfo[]>>(
    `${env.verifyServiceUrl}user/billing_information/`,
    {
      headers: {
        Authorization: authHeader,
      },
    }
  );

export const useBillingInfo = (enabledOverride?: boolean) => {
  const { authHeader, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const canFetch = Boolean(isLoggedIn && authHeader);
  const enabled = enabledOverride ?? canFetch;

  return useQuery({
    queryKey: ["billingInfoData"],
    queryFn: fetch(authHeader),
    enabled,
    retry: false,
    onError: (err: any) => {
      const status =
        err?.response?.status ?? err?.request?.status ?? err?.status;

      if (status === 500 || status === 503) {
        navigate(ROUTE.SERVER_ERROR);
        return;
      }

      if (status === 401) {
        // ✅ Prevent logout loop on login page
        if (location.pathname === ROUTE.LOGIN) return;

        navigate(ROUTE.LOGOUT);
      }
    },
  });
};
